const crashlytics = () => {
  return {
    setAttributes: (value: any) => {
      console.debug('crashlytics Setting attributes: ', value);
    },
    recordError: (value: string | Error) => {
      const valueError = value as Error;
      if (valueError.message) {
        console.debug('crashlytics Sending error: ', valueError.message);
      } else {
        console.debug('crashlytics Sending error: ', value);
      }
    },
    sendUnsentReports: () => {
      console.debug('crashlytics sendUnsentReports');
    },
    setCrashlyticsCollectionEnabled: (value: boolean) => {
      console.debug('crashlytics setCrashlyticsCollectionEnabled value', value);
    },
    setUserId: (uuid: string) => {
      console.debug('crashlytics setUserId uuid', uuid);
    },
  };
};

export default crashlytics;
